// extracted by mini-css-extract-plugin
export default {"container":"main_container__vDyG-","main":"main_main__t6992"};